import { Cookie } from "@/api/policy";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import ReactHtmlParser from 'react-html-parser';
import he from "he";
import { BreadcrumbJsonLd, NextSeo } from "next-seo";
import { Config, isProduction } from "@/config";
import { seoConfig } from "@/config/seo.config";
import { MetaTag } from "next-seo/lib/types";

export default function TermsPage() {
  const [dataCookie, setDataCookie] = useState<string>("");

  const fetchCookieData = async () => {
    try {
      const response = await Cookie();
      setDataCookie(response?.data?.termMsg || "");
    } catch (error) {
      if (!isProduction) {
        console.error("Failed to fetch cookie data:", error);
      }
    }
  };

  const currentUrl = typeof window !== "undefined" ? window.location.href : `${Config.maaBoom}policy/terms`;

  useEffect(() => {
    fetchCookieData();
  }, []);

  return (
    <>
      <BreadcrumbJsonLd
        itemListElements={[
          { position: 1, name: 'หน้าแรก', item: 'https://maaboom.com' },
          { position: 2, name: 'เงื่อนไขในการให้บริการ', item: currentUrl },
        ]}
      />

      <NextSeo
        title="เงื่อนไขในการให้บริการ"
        titleTemplate={`%s | ${seoConfig.title}`}
        defaultTitle={seoConfig.defaultTitle}
        description={seoConfig.description}
        canonical={currentUrl}
        openGraph={{
            ...seoConfig.openGraph,
            url: currentUrl,
            title: `เงื่อนไขในการให้บริการ | ${seoConfig.title}`,
        }}
        additionalMetaTags={[
            ...seoConfig.additionalMetaTags,
            isProduction ? seoConfig.robots.isProduction : seoConfig.robots.isNotProduction,
        ] as MetaTag[]}
        twitter={seoConfig.twitter}
        facebook={seoConfig.facebook}
      />
      
      <Typography gutterBottom>
        {ReactHtmlParser(he.decode(dataCookie).replace(/<\/?p>/g, ''))}
      </Typography>
    </>
  );
}